import React, { useEffect, useRef, useState } from "react";
import { Layout } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Sidebar from "../Sidebar";
import Topbar from "../Topbar";
import Reminder from "../../components/DeviceReminder/reminder";
import ErrorPage from "../../components/ErrorPages/ErrorPage";
import withReducer from "../../appRedux/store/withReducer";
import reducer from "../../appRedux/reducers/receptionist";

import { footerText } from "util/config";
import App from "routes/index";
import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE,
} from "../../constants/ThemeSetting";
import {
  APP_MESSAGE_BROADCAST_CHANNEL,
  REFRESH_TOKEN_INTERVAL_IN_MILLISECONDS,
  AUTHORIZED_ROLES,
} from "../../constants/constants";

import {
  userSignOut,
  authRefresh,
  resetReduxStore,
  NEW_SESSION_CREATED 
} from "../../appRedux/actions";
import { fetchOrganisations, fetchOrganisationsServices } from "../../appRedux/actions/receptionist/organisationsAction";
import { isFeatureEnabled } from "../../util/feature-toogle";

const { Content, Footer } = Layout;

function MainApp({
  width,
  navStyle,
  role,
  userSignOut,
  authRefresh,
  resetReduxStore,
  fetchOrganisations,
  fetchOrganisationsServices

}) {
  const [version, setVersion] = useState(null);
  const refreshIntervalRef = useRef(null);

  const isAuthorizedRole = AUTHORIZED_ROLES.includes(role);
  const grantedRoute = role?.toLowerCase();
  const isDeviceActEnabled = isFeatureEnabled(
    "REACT_APP_FEATURE_TOGGLE_DEVICE_ACTIVATION"
  );

  // Fetch build version
  const fetchVersion = () => {
    fetch("/build-info.json")
      .then((res) => res.json())
      .then((data) => setVersion(data.version))
      .catch((err) =>
        console.error("Error fetching version information", err)
      );
  };

  // Auth refresh interval
  const startAuthRefreshInterval = () => {
    refreshIntervalRef.current = setInterval(
      async () => await authRefresh(false),
      REFRESH_TOKEN_INTERVAL_IN_MILLISECONDS
    );
  };

  // BroadcastChannel listener
  const handleMessageEvent = (e) => {
    const { action, payload } = e.data;
    const activeSessionId = sessionStorage.getItem("USESSIONID");
    if (action === NEW_SESSION_CREATED && activeSessionId !== payload.sessionId) {
      sessionStorage.removeItem("USESSIONID");
      resetReduxStore();
    }
  };

  useEffect(() => {
    // Page unload events
  /*  const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    const handleUnload = () => userSignOut();

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("unload", handleUnload); */

    // Broadcast channel setup
    const channel = new BroadcastChannel(APP_MESSAGE_BROADCAST_CHANNEL);
    channel.addEventListener("message", handleMessageEvent);

    // Init
    startAuthRefreshInterval();
    fetchVersion();
    fetchOrganisations({
      searchText: "",
      page: 0,
      size: 100,
    });
    fetchOrganisationsServices()

    return () => {
      // window.removeEventListener("beforeunload", handleBeforeUnload);
      // window.removeEventListener("unload", handleUnload);
      channel.close();
      clearInterval(refreshIntervalRef.current);
    };
  }, []);

  const getContainerClass = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DARK_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_BELOW_HEADER:
        return "gx-container-wrap";
      case NAV_STYLE_ABOVE_HEADER:
        return "gx-container-wrap";
      default:
        return "";
    }
  };

  const getSidebar = (navStyle, width) => {
    if (width < TAB_SIZE) return <Sidebar />;

    switch (navStyle) {
      case NAV_STYLE_FIXED:
        return <Sidebar />;
      case NAV_STYLE_DRAWER:
        return <Sidebar />;
      case NAV_STYLE_MINI_SIDEBAR:
        return <Sidebar />;
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <Sidebar />;
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <Sidebar />;
      default:
        return null;
    }
  };

  if (!isAuthorizedRole) {
    return (
      <ErrorPage
        errorCode={403}
        errorAction="Logout"
        handleAction={userSignOut}
      />
    );
  }

  return (
    <Layout className="gx-app-layout">
      {getSidebar(navStyle, width)}
      <Layout>
        {isDeviceActEnabled && <Reminder role={role} />}
        <Topbar />
        <Content
          className={`gx-layout-content ${getContainerClass(navStyle)} `}
        >
          <App grantedRoute={grantedRoute} />
          <Footer>
            <div className="gx-flex-row gx-justify-content-start gx-align-items-center">
              <div className="gx-layout-footer-content">{footerText}</div>
              <span className="gx-ml-2">{version}</span>
            </div>
          </Footer>
        </Content>
      </Layout>
    </Layout>
  );
}

export const mapDispatchToProps = dispatch => ({
  userSignOut: bindActionCreators(userSignOut, dispatch),
  authRefresh: bindActionCreators(authRefresh, dispatch),
  resetReduxStore: bindActionCreators(resetReduxStore, dispatch),
  fetchOrganisations: bindActionCreators(fetchOrganisations, dispatch),
  fetchOrganisationsServices: bindActionCreators(fetchOrganisationsServices, dispatch)
});

const mapStateToProps = ({ settings, receptionist, auth  }) => {
  const { width, navStyle } = settings;
  const role = auth?.authUser?.role;
  const { organisationsServices, organisations } = receptionist;  
  return { width, navStyle, organisationsServices, organisations, role }
};

export default withReducer("receptionist", reducer)(connect(mapStateToProps, mapDispatchToProps)(MainApp));
